import { PartnerDeliveryConfigState, PartnerDeliveryConfigTypes, PartnerDeliveryConfigActionTypes } from './types'
import { Reducer } from 'redux'

const initialState: PartnerDeliveryConfigState = {
  deliveryConfigs: []
}

type ActionType = PartnerDeliveryConfigActionTypes
type ReducerOpts = Reducer<PartnerDeliveryConfigState, ActionType>

const reducer: ReducerOpts = (state = initialState, action: ActionType): PartnerDeliveryConfigState => {
  let index = -1
  switch (action.type) {
    case PartnerDeliveryConfigTypes.PARTNER_DELIVERY_CONFIG_CREATE:
      return { ...state, deliveryConfigs: [...state.deliveryConfigs, action.payload] }
    case PartnerDeliveryConfigTypes.PARTNER_DELIVERY_CONFIG_UPDATE:
      index = state.deliveryConfigs.findIndex(item => item.id === action.payload.id)
      return {
        ...state,
        deliveryConfigs: [
          ...state.deliveryConfigs.slice(0, index),
          action.payload,
          ...state.deliveryConfigs.slice(index + 1)
        ]
      }
    case PartnerDeliveryConfigTypes.PARTNER_DELIVERY_CONFIG_DELETE:
      index = state.deliveryConfigs.findIndex(item => item.id === action.payload)
      return {
        ...state,
        deliveryConfigs: [
          ...state.deliveryConfigs.slice(0, index),
          ...state.deliveryConfigs.slice(index + 1)
        ]
      }
    case PartnerDeliveryConfigTypes.PARTNER_DELIVERY_CONFIG_GET_LIST:
      return { ...state, deliveryConfigs: action.payload }
    default:
      return state
  }
}

export default reducer
